import React from 'react';
import { images } from '../data/images';
import { scrollToSection } from '../utils/scrollToSection';
type Props = {
  tone?: 'light' | 'dark';
  className?: string;
  size?: 'sm' | 'md';
};
export function Logo({
  tone = 'light',
  className = '',
  size = 'md'
}: Props) {
  return <a href="#home" onClick={event => scrollToSection(event, '#home')} aria-label="Lima Dental Group, back to top" className={`group flex items-center gap-3 ${className}`} data-id="element-363" data-mp="3v8nxvvv242j9">
      <img src={images.logo} alt="Lima Dental Group" className={`w-auto transition-opacity duration-300 group-hover:opacity-80 ${size === 'sm' ? 'h-6' : 'h-7 lg:h-8'} ${tone === 'dark' ? 'brightness-0' : ''}`} data-id="element-364" data-mp="rrp8d68ujlxe" />
      <span aria-hidden="true" className={`hidden h-4 w-px sm:block ${tone === 'dark' ? 'bg-ink/20' : 'bg-white/25'}`} data-id="element-365" data-mp="hrydv4kad6xb" />
      <span className={`eyebrow hidden pt-[1px] sm:block ${tone === 'dark' ? 'text-ink/55' : 'text-white/60'}`} data-id="element-366" data-mp="32k8s7zxtewkl">
        Dental Group
      </span>
    </a>;
}